import { getItemFromCollection, getItemsFromCollection } from "directus/src/operations";

export async function fetchExtension({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "end_date",
        "start_date",
        "justification",
        "category.id",
        "category.label",
        "reason.id",
        "reason.label",
        "reason",
        "status",
        "job",
        "date_created",
      ],
    };
    const data = await getItemFromCollection("job_extensions", id, query);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchExtensionCategories() {
  try {
    const query = {
      filter: {
        parent: {
          value: { _eq: "job_extension_categories" }
        },
        status: {
          _eq: "published"
        },
        children: {
          status: {
            _eq: "published"
          }
        }
      },
      fields: [
        "id",
        "status",
        "label",
        "value",
        "description",
        "children.id",
        "children.status",
        "children.label",
        "children.value",
        "children.description",
      ],
    };
    const data = await getItemsFromCollection("options", query);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

